import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from '../../styles/dialogbox/Popup.module.css'; // Assuming you have a CSS module for styling

const EarlyAccessPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [hasSeenPopup, setHasSeenPopup] = useState(false);

  useEffect(() => {
    // Check if user has already seen the popup (using localStorage)
    const popupSeen = localStorage.getItem('earlyAccessPopupSeen');
    
    if (!popupSeen) {
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 3000); // Show popup after 3 seconds
      
      return () => clearTimeout(timer);
    } else {
      setHasSeenPopup(true);
    }
  }, []);

  const closePopup = () => {
    setIsVisible(false);
    // Mark popup as seen in localStorage
    localStorage.setItem('earlyAccessPopupSeen', 'true');
    setHasSeenPopup(true);
  };

  if (hasSeenPopup) {
    return null;
  }

  return (
    <div className={`${styles.popupContainer} ${isVisible ? styles.visible : ''}`}>
      <div className={styles.overlay} onClick={closePopup}></div>
      <div className={styles.popup}>
        <button className={styles.closeButton} onClick={closePopup}>
          ×
        </button>
        
        <div className={styles.popupContent}>
          <div className={styles.badge}>Limited Time Offer</div>
          <h2 className={styles.title}>Free Premium Access</h2>
          <p className={styles.description}>
            We're giving early users <strong>completely free access</strong> to our premium features.
            Unlock unlimited stock data, advanced analytics, and more!
          </p>
          
          <div className={styles.features}>
            <span>✓ Unlimited Stocks Data Entry</span>
            <span>✓ Advanced Analytics</span>
            <span>✓ CSV Exports</span>
          </div>
          
          <Link to="/login" className={styles.claimButton} onClick={closePopup}>
            Claim Your Free Access
          </Link>
          
          <p className={styles.timer}>
            This offer is available for a limited time only
          </p>
        </div>
      </div>
    </div>
  );
};

export default EarlyAccessPopup;